import React, { PropsWithChildren } from 'react';
import * as styles from '../styles/filter.module.scss';

interface Props {
  selected: boolean;
  onClick: () => void;
}

const Filter: React.FC<PropsWithChildren<Props>> = ({
  selected,
  children,
  onClick,
}) => {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      href='#'
      className={selected ? styles.filter_link_selected : styles.filter_link}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      {children}
    </a>
  );
};

export default Filter;
